import { AppError } from "config/errors";
import { fetchPreVerifiedInitialData, fetchVerifiedInitialData } from "gql/queries/appLoad";
import { endRequest, startRequest } from "store/actions/request";
import { getActiveAccount } from "utils/account";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "lodash-es";

/* ------------       THUNKS      ------------------ */

export const getPreVerifiedInitialData = createAsyncThunk(
  "appLoad/getPreVerifiedInitialData",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await fetchPreVerifiedInitialData();
      const me = get(data, "me");

      return { me };
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);

export const getVerifiedInitialData = createAsyncThunk(
  "appLoad/getVerifiedInitialData",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      await dispatch(startRequest("appLoad"));

      const { data } = await fetchVerifiedInitialData();
      const me = get(data, "me");

      const account = getActiveAccount(me);

      return { account, me };
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    } finally {
      await dispatch(endRequest("appLoad"));
    }
  }
);
